import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/Load',
      params,
    });
  },
  LoadTeacher(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/LoadTeacher',
      params,
    });
  },
  LoadStudent(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/LoadStudent',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/Get',
      params,
    });
  },
  GetWorkByCourseId(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/GetWorkByCourseId',
      params,
    });
  },

  FindByIdTeacher(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/FindByIdTeacher',
      params,
    });
  },
  FindByIdStudent(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_CourseSchedule/FindByIdStudent',
      params,
    });
  },
  AddMakeUp(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_CourseSchedule/AddMakeUp',
      data,
    });
  },
  UpdateMakeUp(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_CourseSchedule/UpdateMakeUp',
      data,
    });
  },
};
